export default {
  state: {
    recommendationList: null,
    recommendationTotalCount: null,
    recommendationSingle: null,
    recommendationStatistics: null,
    recommendationStatisticsTotalCount: null,
    recommendationStatisticsRequestId: null
  },
  mutations: {
    setRecommendationList (state, payload) {
      state.recommendationList = []
      state.recommendationList = payload
    },
    setRecommendationTotalCount (state, payload) {
      state.recommendationTotalCount = payload
    },
    setRecommendationSingle (state, payload) {
      state.recommendationSingle = payload
    },
    setRecommendationStatistics (state, payload) {
      state.recommendationStatistics = payload
    },
    setRecommendationStatisticsTotalCount (state, payload) {
      state.recommendationStatisticsTotalCount = payload
    },
    setRecommendationStatisticsRequestId (state, payload) {
      state.recommendationStatisticsRequestId = payload
    }
  },
  actions: {
    async getRecommendationList ({commit, dispatch}, {mode, offset, limit}) {
      const url = '/admin/recommendation/list?access_token=' + this.getters.accessToken + '&mode=' + mode + '&offset=' + offset + '&limit=' + limit
      await dispatch('apiGet', url)
        .then((data) => {
          commit('setRecommendationList', data.recommendation_list)
          commit('setRecommendationTotalCount', data.total_count)
        })
        .catch((error) => {
          throw error
        })
    },
    getRecommendationSingle ({commit, dispatch}, {id}) {
      const url = '/admin/recommendation/' + id + '/single?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setRecommendationSingle', data.recommendation)
        })
        .catch((error) => {
          throw error
        })
    },
    async deleteRecommendation ({commit, dispatch}, {id}) {
      let post = {
        data: {
          id: id
        }
      }
      post.url = '/admin/recommendation/' + id + '/remove?access_token=' + this.getters.accessToken
      await dispatch('apiPost', post)
        .then((data) => {
          commit('setSuccess', 'Рекомендация удалена успешно')
        })
        .catch((error) => {
          throw error
        })
    },
    async createRecommendation ({commit, dispatch}, recommendationData) {
      let post = {
        data: {
          title: recommendationData.title,
          start_date: recommendationData.startDate,
          end_date: recommendationData.endDate,
          bonus_percent: recommendationData.bonusPercent
        }
      }

      if (typeof recommendationData.bonusMaxSum !== 'undefined') {
        post.data.bonus_max_sum = recommendationData.bonusMaxSum
      }
      if (typeof recommendationData.description !== 'undefined') {
        post.data.description = recommendationData.description
      }
      if (typeof recommendationData.minOrderSum !== 'undefined') {
        post.data.min_order_sum = recommendationData.minOrderSum
      }
      if (typeof recommendationData.minOrderWeight !== 'undefined') {
        post.data.min_order_weight = recommendationData.minOrderWeight
      }
      if (typeof recommendationData.pointFolderIdList !== 'undefined') {
        post.data.point_folder_id_list = recommendationData.pointFolderIdList
      }
      if (typeof recommendationData.pointIdList !== 'undefined') {
        post.data.point_id_list = recommendationData.pointIdList
      }
      if (typeof recommendationData.productGroupList !== 'undefined') {
        post.data.recommendation_product_group_update_list = recommendationData.productGroupList
      }

      let returnData = null
      if (recommendationData.id === null) {
        post.url = '/admin/recommendation/add?access_token=' + this.getters.accessToken
        await dispatch('apiPost', post)
          .then((data) => {
            commit('setSuccess', 'Рекомендация создана успешно')
            returnData = data
          })
          .catch((error) => {
            throw error
          })
      } else {
        post.id = recommendationData.id
        post.url = '/admin/recommendation/' + recommendationData.id + '/update?access_token=' + this.getters.accessToken

        await dispatch('apiPost', post)
          .then((data) => {
            commit('setSuccess', 'Рекомендация изменена успешно')
            returnData = data
          })
          .catch((error) => {
            throw error
          })
      }
      return returnData
    },
    getRecommendationStatistics ({commit, dispatch, state}, {id, q, branchId, limit, offset}) {
      let urlQ = ''
      if (q !== null && typeof q !== 'undefined') {
        urlQ = '&q=' + q
      }

      let urlBranchId = ''
      if (branchId !== null && typeof branchId !== 'undefined') {
        urlBranchId = '&branch_id=' + branchId
      }

      let urlOffset = ''
      if (offset !== null && typeof offset !== 'undefined') {
        urlOffset = '&offset=' + offset
      }

      let urlLimit = ''
      if (limit !== null && typeof limit !== 'undefined') {
        urlLimit = '&limit=' + limit
      }

      const url = '/admin/recommendation/' + id + '/statistics/list?access_token=' + this.getters.accessToken + urlQ + urlBranchId + urlLimit + urlOffset
      let requestId = setTimeout(function () {
        dispatch('apiGet', url)
          .then((data) => {
            if (requestId === state.recommendationStatisticsRequestId) {
              console.log(data)
              commit('setRecommendationStatistics', data.recommendation_statistics_list)
              commit('setRecommendationStatisticsTotalCount', data.total_count)
            }
          })
          .catch((error) => {
            throw error
          })
      }, 100)
      commit('setRecommendationStatisticsRequestId', requestId)
    }
  },
  getters: {
    recommendationList (state) {
      return state.recommendationList
    },
    recommendationTotalCount (state) {
      return state.recommendationTotalCount
    },
    recommendationSingle (state) {
      return state.recommendationSingle
    },
    recommendationStatistics (state) {
      return state.recommendationStatistics
    },
    recommendationStatisticsTotalCount (state) {
      return state.recommendationStatisticsTotalCount
    },
    recommendationStatisticsRequestId (state) {
      return state.recommendationStatisticsRequestId
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/recommendation.js